import React from 'react'

import { Carousel } from '../components/_common'
import { Us, OurServices, Blog, Contact } from '../components/IndexModule'
import { Layout } from '../components/_layout'

const Homepage = () => {
  return (
    <Layout withNav seoTitle="Inicio">
      <Carousel />
      <Us />
      <OurServices />
      <Blog />
      <Contact />
    </Layout>
  )
}

export default Homepage
